<template>
  <div class="flex-grow mx-auto container p-8 text-xl">
    <HeroCreator />
    <!-- <ScreenSizePicker /> -->
  </div>
</template>

<script>
// @ is an alias to /src
import HeroCreator from '@/components/HeroCreator.vue'
// import ScreenSizePicker from '@/components/ScreenSizePicker.vue'

export default {
  name: 'HeroView',
  components: {
    HeroCreator
    // ScreenSizePicker
  }
}
</script>
